import { cva, type VariantProps } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center rounded-full gap-2 border px-2.5 py-0.5 text-sm transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 font-semibold shadow-none border-none',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/80',
        outline: 'text-foreground',
        gradient: 'bg-badge text-white border-transparent',
        pending: 'bg-amber-50 text-amber-700 hover:bg-amber-50/80 hover:text-amber-700/90',
        invited: 'bg-yellow-50 text-yellow-700 hover:bg-yellow-50/80 hover:text-yellow-700/90 ',
        paid: 'bg-green-50 text-green-700 hover:bg-green-50/80 hover:text-green-700/90',
        released: 'bg-yellow-50 text-yellow-700 hover:bg-yellow-50/80 hover:text-yellow-700/90',
        expired: 'bg-orange-100 text-orange-700 hover:bg-orange-100/80 hover:text-orange-700/90',
        active: 'bg-green-50 text-green-700 hover:bg-green-50/80 hover:text-green-700/90',
        canceled: 'bg-red-50 text-red-700 hover:bg-red-50/80 hover:text-red-700/90',
        canceled_by_order: 'bg-red-50 text-red-700 hover:bg-red-50/80 hover:text-red-700/90',
        canceled_by_admin: 'bg-red-50 text-red-700 hover:bg-red-50/80 hover:text-red-700/90',
        used: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-100/80 hover:text-yellow-700/90',
        disabled: 'bg-gray-100 text-gray-700 hover:bg-gray-100/80 hover:text-gray-700/90',
        refunded: 'bg-red-50 text-red-700 hover:bg-red-50/80 hover:text-red-700/90',
        success: 'bg-green-100 text-sm font-medium text-green-800 ',
        ticket_generated: 'bg-green-100 text-sm font-medium text-green-800 ',
        upgraded: 'bg-blue-100 text-sm font-medium text-blue-800',
        revoked: 'bg-[#FBEDDD] text-primary text-sm font-medium'
      },
    },

    defaultVariants: {
      variant: 'default',
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
